/**
 * NOTE - this is to assist with VR tests so we can easily di the value for the
 * dropdowns to be opened.
 * @param _ name of your component
 * @returns false in production code
 */
export const getIsDropdownDefaultOpen = (_: string) => false;
